// Hook for grid line placement operations
import { handleGridLinePlacement as handleGridLinePlacementUtil } from "../utils/gridLinePlacementUtils";
import { useCallback } from "react";

/**
 * Hook for grid line placement operations
 */
const useGridLinePlacement = (
  pdfState,
  tableState,
  gridLineState,
  drawingState,
  refs,
  recalculateCellsFromGridLinesWrapper
) => {
  const { currentPage } = pdfState;
  const { selectedTable, tableData } = tableState;
  const {
    isPlacingGridLine,
    placingGridLineType,
    dynamicGridLines,
  } = gridLineState;
  const { drawingMode } = drawingState;
  const { canvasRef, highlightContainerRef, pdfPageDimensions } = refs;

  const handleGridLinePlacement = useCallback(
    (event) => {
      handleGridLinePlacementUtil(event, {
        isPlacingGridLine,
        placingGridLineType,
        dynamicGridLines,
        currentPage,
        drawingMode,
        selectedTable,
        tableData,
        pdfPageDimensions,
        canvasRef,
        highlightContainerRef,
        gridLineState,
        drawingState,
        recalculateCellsFromGridLinesWrapper,
      });
    },
    [
      isPlacingGridLine,
      placingGridLineType,
      dynamicGridLines,
      currentPage,
      drawingMode,
      selectedTable,
      tableData,
      pdfPageDimensions,
      canvasRef,
      highlightContainerRef,
      gridLineState,
      drawingState,
      recalculateCellsFromGridLinesWrapper,
    ]
  );

  const startAddNewRow = useCallback(() => {
    if (!tableData) return;

    // Enter placement mode for rows
    gridLineState.setIsPlacingGridLine(true);
    gridLineState.setPlacingGridLineType("row");
    gridLineState.setPlacingGridLinePosition(null);

    // Clear other modes
    drawingState.setDrawingMode(null);
    drawingState.setIsDrawing(false);
    gridLineState.setGridLineDragMode(false);
  }, [tableData, gridLineState, drawingState]);

  const startAddNewColumn = useCallback(() => {
    if (!tableData) {
      return;
    }

    // Enter placement mode for columns
    gridLineState.setIsPlacingGridLine(true);
    gridLineState.setPlacingGridLineType("column");
    gridLineState.setPlacingGridLinePosition(null);

    // Clear other modes
    drawingState.setDrawingMode(null);
    drawingState.setIsDrawing(false);
    gridLineState.setGridLineDragMode(false);
  }, [tableData, gridLineState, drawingState]);

  return {
    handleGridLinePlacement,
    startAddNewRow,
    startAddNewColumn,
  };
};

export default useGridLinePlacement;
